import Chip from "./Chip";

const PersonaFitDetail = ({ result }) => {
  const fitScore = result.fit_score ?? 0;
  const reservations = result.reservations ?? [];
  const citedAttributes = result.cited_attributes ?? [];

  const fitColor =
    fitScore >= 7 ? "text-emerald-400" : fitScore >= 4 ? "text-yellow-400" : "text-orange-400";

  const factorBreakdown = [
    { label: "Mention", pts: result.mention_pts ?? 0, max: 40, color: "bg-blue-500" },
    { label: "Rank", pts: result.rank_pts ?? 0, max: 30, color: "bg-purple-500" },
    { label: "Fit", pts: result.fit_pts ?? 0, max: 20, color: "bg-emerald-500" },
    { label: "Cross-Engine", pts: result.cross_engine_pts ?? 0, max: 10, color: "bg-amber-500" },
  ];

  return (
    <div className="space-y-4">
      {/* Score breakdown */}
      <div className="bg-surface-container-low rounded-xl p-4 border border-surface-container-high">
        <h4 className="text-sm font-semibold text-on-surface-variant mb-3">Score Breakdown</h4>
        <div className="space-y-2">
          {factorBreakdown.map((f) => (
            <div key={f.label} className="flex items-center gap-3">
              <span className="text-xs text-on-surface-variant w-24 shrink-0">{f.label}</span>
              <div className="flex-1 bg-surface-container-high rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${f.color}`}
                  style={{ width: `${(f.pts / f.max) * 100}%` }}
                />
              </div>
              <span className="text-xs font-mono text-on-surface w-12 text-right">
                {f.pts}/{f.max}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Fit score */}
      {fitScore > 0 && (
        <div className="bg-surface-container-low rounded-xl p-4 border border-surface-container-high">
          <div className="flex items-center justify-between mb-3">
            <h4 className="text-sm font-semibold text-on-surface-variant">AI Fit Assessment</h4>
            <span className={`text-2xl font-extrabold font-headline ${fitColor}`}>
              {fitScore.toFixed(1)}/10
            </span>
          </div>

          {citedAttributes.length > 0 && (
            <div className="mb-3">
              <p className="text-xs text-emerald-600 font-semibold mb-1">Cited Attributes</p>
              <div className="flex flex-wrap gap-1.5">
                {citedAttributes.map((attr, i) => (
                  <Chip key={i} color="emerald">
                    {attr}
                  </Chip>
                ))}
              </div>
            </div>
          )}

          {reservations.length > 0 && (
            <div>
              <p className="text-xs text-orange-600 font-semibold mb-1">AI Reservations</p>
              <ul className="space-y-1">
                {reservations.map((r, i) => (
                  <li key={i} className="text-xs text-on-surface-variant flex gap-1.5">
                    <span className="text-orange-400 mt-0.5">•</span>
                    {r}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PersonaFitDetail;
